import React from 'react';
import './sourcesAndDisclimers.scss';
import { Link } from 'react-router-dom';
import GuideLinesDialog from '../Dailog/GuidelinesDialog';
var SourcesAnddisclimersTab = function () {
    var _a = React.useState(false), showDialog = _a[0], setShowDdialog = _a[1];
    var _b = React.useState(""), modalTitle = _b[0], setModalTitle = _b[1];
    var handleClick = function (e) {
        setModalTitle(e.currentTarget.innerText);
        setShowDdialog(true);
    };
    return (React.createElement("div", { className: 'wrapper' },
        React.createElement("div", { className: 'title' }, "Sources And Disclaimers"),
        React.createElement("div", { className: 'link_container' },
            React.createElement(Link, { to: "https://www.aon.com/about-aon/legal-notice.jsp", target: '_blank', rel: 'noopener' }, "Aon Plc"),
            React.createElement(Link, { onClick: handleClick, to: "" }, "AM Best Company, Inc."),
            React.createElement(Link, { onClick: handleClick, to: "" }, "Standard & Poor Financial Service LLC"),
            React.createElement(Link, { to: "" }, "S&P Global Market Intelligence LLC ")),
        showDialog && React.createElement(GuideLinesDialog, { showDialog: showDialog, heading: modalTitle, onClickClose: function () { setModalTitle(""); setShowDdialog(false); } })));
};
export default SourcesAnddisclimersTab;
